import Vue from 'vue';
import ElementUI from 'element-ui';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import 'element-ui/lib/theme-chalk/index.css';
import GlobalVariables from '@/assets/js/global-variables';
import '@/assets/css/index.css';
import EleImage from 'vue-ele-image';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import VueQuillEditor from 'vue-quill-editor';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
import ImageCompress from 'quill-image-compress';
import ImageUploader from 'quill-image-uploader';

import App from './App.vue';
import router from './router';

Quill.register('modules/imageUploader', ImageUploader);
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageCompress', ImageCompress);

Vue.prototype.GlobalVariables = GlobalVariables;

Vue.config.productionTip = false;
Vue.use(ElementUI, { zhTWLocale });
Vue.use(EleImage);
Vue.use(VueQuillEditor);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
